import * as React from 'react';

function SvgEnvelopeOpen(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8.47 1.318a1 1 0 00-.94 0l-6 3.2A1 1 0 001 5.4v.818l5.724 3.465L8 8.917l1.276.766L15 6.218V5.4a1 1 0 00-.53-.882l-6-3.2zM15 7.388l-4.754 2.877L15 13.117v-5.73zm-.035 6.874L8 10.083l-6.965 4.18A1 1 0 002 15h12a1 1 0 00.965-.738zM1 13.117l4.754-2.852L1 7.387v5.73zM7.059.435a2 2 0 011.882 0l6 3.2A2 2 0 0116 5.4V14a2 2 0 01-2 2H2a2 2 0 01-2-2V5.4a2 2 0 011.059-1.765l6-3.2z' />
		</svg>
	);
}

export default SvgEnvelopeOpen;
